export const PaymentDetailsTypes = {
  CryptoWallet: 'cryptoWallet',
  BankAccount: 'bankAccount',
};

export const PaymentDetailsTypesAll = [
  PaymentDetailsTypes.BankAccount,
  PaymentDetailsTypes.CryptoWallet,
];
